/**
 * Normalize author name for consistent matching
 * Removes punctuation and extra whitespace, converts to lowercase
 */
export function normalizeAuthorName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^\w\s]/g, '') // Remove punctuation
    .replace(/\s+/g, ' ')    // Normalize whitespace
    .trim();
}

/**
 * Check if two author names likely refer to the same person
 * Handles common variations like "J.K. Rowling" vs "JK Rowling" vs "Rowling, J.K."
 */
export function matchAuthorVariations(name1: string, name2: string): boolean {
  const normalized1 = normalizeAuthorName(name1);
  const normalized2 = normalizeAuthorName(name2);
  
  if (normalized1 === normalized2) return true;
  
  // Check if one is a subset of the other (e.g., "Rowling" matches "J.K. Rowling")
  if (normalized1.includes(normalized2) || normalized2.includes(normalized1)) {
    return true;
  }
  
  return false;
}

/**
 * Extract canonical author name from variations
 * Prefers the longest/most complete version
 */
export function getCanonicalAuthorName(variations: string[]): string {
  if (variations.length === 0) return '';
  if (variations.length === 1) return variations[0];
  
  // Return the longest name (usually the most complete)
  return variations.reduce((longest, current) => 
    current.length > longest.length ? current : longest
  );
}
